import React, { useContext } from 'react';
import { useLocation } from '@reach/router';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { NavContext } from '@components/navigation/Context';
import IconBurger from '@components/navigation/NavBarMobileIconBurger';
import useDesktop from '@components/shared/useDesktop';
import { ALL_PRODUCTS_URL, HAMBURGER_BREAKPOINT, HORMONAL_HEALTH_URL, PERIOD_CARE_URL, PERIOD_PAIN_CLINIC_URL, VAGINAL_HEALTH_URL } from '@constants';
import { NavBarCategory, NavStatus } from '@contracts';
import { pageIsFocusPage, pageIsAccountPage } from '@utils/helpers';
import NavBarLink, { NavBarLinksWrap } from './NavBarLink';

interface Props {}

const NavBarLeft: React.FC<Props> = () => {
  const { navState, navDispatch } = useContext(NavContext);
  const { status, navbarItemColor, navbarSelectedCategories } = navState;
  const hamburgerDesktop = useDesktop(HAMBURGER_BREAKPOINT);
  const location = useLocation();
  const isCheckoutPage = location.pathname.includes('/checkout/');
  const isAccountPage = pageIsAccountPage(location.pathname);
  const isFocusPage = pageIsFocusPage(location.pathname);
  const { t } = useTranslation();
  const isSearch = navbarSelectedCategories?.length ? navbarSelectedCategories.includes(NavBarCategory.Search) : false;

  const handleMenuClick = () => {
    if (status === NavStatus.Default || isSearch) {
      navDispatch({ type: 'removeNavbarSelectedCategories' });
      navDispatch({ type: 'setStatus', data: NavStatus.Menu });
    } else {
      navDispatch({ type: 'setStatus', data: NavStatus.Default });
    }
  };

  if (isFocusPage || isCheckoutPage || (isAccountPage && hamburgerDesktop)) return null;

  return (
    <>
      <BurgerStyled $color={navbarItemColor} $active={status === NavStatus.Menu}>
        <IconBurger
          handleClick={handleMenuClick}
          isClose={hamburgerDesktop ? status === NavStatus.Menu : status !== NavStatus.Default && !isSearch}
        />
      </BurgerStyled>
      <NavBarLinksWrap>
        <NavBarLink text={t('components.shop')} category={NavBarCategory.Shop} navbarLink={ALL_PRODUCTS_URL} />
        <NavBarLink text={t('components.vaginal-health')} navbarLink={VAGINAL_HEALTH_URL} />
        <NavBarLink text={t('components.hormonal-health')} navbarLink={HORMONAL_HEALTH_URL} isNew={true} />
        <NavBarLink text={t('components.period-pain-clinic-old')} navbarLink={PERIOD_PAIN_CLINIC_URL} />
      </NavBarLinksWrap>
    </>
  );
};

export default NavBarLeft;

const BurgerStyled = styled.div<{ $color?: string; $active?: boolean | undefined }>`
  display: none;
  height: 19px;

  @media (max-width: ${HAMBURGER_BREAKPOINT}px) {
    display: flex;
  }

  .hamburger {
    height: 19px;
  }

  .hamburger-inner,
  .hamburger-inner::before,
  .hamburger-inner::after {
    background-color: ${(props) => props.$color};
  }

  ${(props) => {
    if (props.$active) {
      return `
      .hamburger-inner,
      .hamburger-inner::before,
      .hamburger-inner::after {
        background-color: ${props.$color};
      }
      `;
    }

    return '';
  }};
`;
